const SavedTabViews = self => ({
    get allContacts() {
        if (self.savedContacts.size === 0) {
            return [];
        }
        return Array.from(self.savedContacts.values());
    },
    get selectedContact() {
        return self.savedContacts.get(self.selectedContactId);
    },
    get selectedCompanyContact() {
        var _a;
        return (_a = self.savedContacts.get(self.selectedContactId)) === null || _a === void 0 ? void 0 : _a.company;
    },
    get listNameBySelectedList() {
        var _a;
        return (_a = self.allLists.find(list => list.listKey === self.selectedList)) === null || _a === void 0 ? void 0 : _a.name;
    },
});
export default SavedTabViews;
